import { Stack, Typography } from "@mui/material";
import { BasicCardStack, StyledItemRow } from "./styles";
import ItemTableRow from "./ItemTableRow";

const toComma = (n) => Number(n).toLocaleString();
const ItemTable = ({ items = [], hidePrice = false, hideBoxes = false }) => {
  return (
    <BasicCardStack sx={{ padding: 0, gap: 0 }} justifyContent="space-between">
      <Stack>
        <StyledItemRow header>
          <Typography variant="caption">Qty</Typography>
          <Typography variant="caption">Description</Typography>
          <Typography variant="caption">Part #</Typography>
          <Typography variant="caption">Lot #</Typography>
        </StyledItemRow>
        {items?.map((item, idx) => (
          <ItemTableRow
            item={item}
            idx={idx}
            hidePrice={hidePrice}
            hideBoxes={hideBoxes}
          />
        ))}
      </Stack>
    </BasicCardStack>
  );
};

export default ItemTable;
